import type { FC } from 'react';
import { Button, InlineLoading } from '@carbon/react';
import { ArrowRight } from '@carbon/icons-react';

import { PaginaDeAuth } from '../../../padroes/PaginaDeAuth';
import { ROTULOS } from '../../../padroes/rotulos';
import styles from '../auth.module.scss';

// AS BOAS-VINDAS: a saudação (a de quem vai criar o primeiro perfil, ou a de quem tem um convite)
// e o primário que leva ao lugar certo. Enquanto não se sabe quem chegou, um `InlineLoading`.

export const BoasVindas: FC<{ pronto: boolean; saudacao: string; botao: string; comecar: () => void }> = ({
  pronto, saudacao, botao, comecar,
}) => (
  <PaginaDeAuth titulo='Sua conta está pronta'>
    {pronto ? (
      <>
        <p className={styles.texto}>{saudacao}</p>
        <div>
          <Button renderIcon={ArrowRight} onClick={comecar}>{botao}</Button>
        </div>
      </>
    ) : (
      <InlineLoading description='Preparando…' iconDescription={ROTULOS.carregando} />
    )}
  </PaginaDeAuth>
);
